import React from "react";

export default function PhotoInfoPopup({ onClose, onGoToCamera }) {
  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose} aria-label="Cerrar">
          ✕
        </button>
        <h2>Apunta tu comida con una foto</h2>
        <p className="popup-texto">
          Haz una foto del plato y elige qué es de tu recetario: las calorías se rellenan
          solas. La foto se queda en tu dispositivo.
        </p>
        <button className="app-btn" onClick={onGoToCamera}>
          Abrir la cámara
        </button>
      </div>
    </div>
  );
}
